module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/share.68b8843f.jpg";